export default "__VITE_ASSET__BoX$bT1E__"